import React from "react";

interface PaginationDotsProps {
  total: number;
  current: number;
  mobileOnly?: boolean;
  desktopOnly?: boolean;
}

export const PaginationDots: React.FC<PaginationDotsProps> = ({
  total,
  current,
  mobileOnly = false,
  desktopOnly = false,
}) => {
  const getVisibilityClass = () => {
    if (mobileOnly) return "flex md:hidden";
    if (desktopOnly) return "hidden md:flex";
    return "flex";
  };

  const getDotClass = (index: number) => {
    if (index === current) return "bg-brand-dark";
    if (index < current) return "bg-brand-300";
    return "bg-putty-500";
  };

  return (
    <div
      className={`${getVisibilityClass()} gap-4 items-center justify-center`}
    >
      {Array.from({ length: total }, (_, index) => (
        <div
          key={`pagination-${index}`}
          className={`h-2 w-2 rounded-full ${getDotClass(index)}`}
        />
      ))}
    </div>
  );
};
